<template>
  <aside class="ovg-resumen" :class="{ 'ovg-resumen--placeholder': !cliente }">
    <h3 class="ovg-resumen__title">Resumen de tu Solicitud</h3>

    <template v-if="!cliente">
      <p class="ovg-resumen__placeholder-text">
        A medida que avances, aquí verás el detalle de tus datos, tu equipo y la
        cobertura seleccionada.
      </p>
      <img
        src="@/assets/ovg-resumen-placeholder.png"
        alt=""
        width="287"
        height="287"
        class="ovg-resumen__placeholder-img"
      />
    </template>

    <template v-else>
      <div class="ovg-resumen__group">
        <span class="ovg-resumen__group-label">Datos del Cliente:</span>
        <div class="ovg-resumen__pair">
          <span class="ovg-resumen__label ovg-resumen__label--accent"
            >R.U.T</span
          >
          <span class="ovg-resumen__value">{{ cliente.rut }}</span>
        </div>
        <div class="ovg-resumen__pair">
          <span class="ovg-resumen__label">Nombre</span>
          <span class="ovg-resumen__value">{{ cliente.nombre }}</span>
        </div>
        <div class="ovg-resumen__pair">
          <span class="ovg-resumen__label">Apellido</span>
          <span class="ovg-resumen__value">{{ cliente.apellido }}</span>
        </div>
        <div class="ovg-resumen__pair">
          <span class="ovg-resumen__label">Correo Electrónico</span>
          <span class="ovg-resumen__value">{{ cliente.correo }}</span>
        </div>
        <div class="ovg-resumen__pair">
          <span class="ovg-resumen__label">Teléfono</span>
          <span class="ovg-resumen__value">{{ cliente.telefono || '—' }}</span>
        </div>
      </div>

      <template v-if="equipo">
        <hr class="ovg-resumen__separator" />
        <div class="ovg-resumen__group">
          <span class="ovg-resumen__group-label">Datos del Equipo:</span>
          <div class="ovg-resumen__pair">
            <span class="ovg-resumen__label ovg-resumen__label--accent"
              >N° De Serie Equipo</span
            >
            <span class="ovg-resumen__value">{{ equipo.numero_serie }}</span>
          </div>
          <div class="ovg-resumen__pair">
            <span class="ovg-resumen__label">Modelo del Equipo</span>
            <span class="ovg-resumen__value">{{ equipo.modelo_nombre }}</span>
          </div>
        </div>
      </template>

      <template v-if="extension">
        <hr class="ovg-resumen__separator" />
        <div class="ovg-resumen__group">
          <span class="ovg-resumen__group-label">Extensión de Garantía</span>
          <div class="ovg-resumen__pair">
            <span class="ovg-resumen__label">{{ extension.nombre }}</span>
            <span class="ovg-resumen__value"
              >{{ extension.vigencia_meses }} meses de cobertura</span
            >
          </div>
        </div>
      </template>

      <template v-if="proteccionesAMostrar.length">
        <hr class="ovg-resumen__separator" />
        <div class="ovg-resumen__group">
          <span class="ovg-resumen__group-label">Protección Adicional</span>
          <div
            v-for="p in proteccionesAMostrar"
            :key="p.id"
            class="ovg-resumen__pair"
          >
            <span class="ovg-resumen__value">{{ p.nombre }}</span>
          </div>
        </div>
      </template>
    </template>
  </aside>
</template>

<script>
export default {
  name: 'ResumenSolicitudPanel',
  props: {
    proteccionesPreview: {
      type: Array,
      default: null,
    },
  },
  computed: {
    cliente() {
      return this.$store.getters['OVGStore/cliente']
    },
    equipo() {
      return this.$store.getters['OVGStore/equipo']
    },
    extension() {
      return this.$store.getters['OVGStore/extension']
    },
    proteccionesAMostrar() {
      return this.proteccionesPreview !== null
        ? this.proteccionesPreview
        : this.$store.getters['OVGStore/protecciones'] || []
    },
  },
}
</script>

<style scoped>
.ovg-resumen {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  width: 360px;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: 'Noto Sans', sans-serif;
  box-sizing: border-box;
}

.ovg-resumen--placeholder {
  gap: 24px;
}

.ovg-resumen__title {
  font-family: 'Noto Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #23201c;
  line-height: 25px;
  margin: 0;
}

.ovg-resumen__placeholder-text {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
  line-height: 20px;
  margin: 0;
}

.ovg-resumen__placeholder-img {
  width: 287px;
  height: 287px;
  align-self: center;
}

.ovg-resumen__group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ovg-resumen__group-label {
  font-size: 15px;
  font-weight: 700;
  color: #23201c;
}

.ovg-resumen__pair {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ovg-resumen__label {
  font-size: 15px;
  font-weight: 700;
  color: #525252;
}

.ovg-resumen__label--accent {
  color: #1d4ed8;
}

.ovg-resumen__value {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
}

.ovg-resumen__separator {
  border: none;
  border-top: 1px solid #d2d2d2;
  margin: 0;
  width: 100%;
}
</style>
